import { Component, OnInit, OnDestroy, Input, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription, distinctUntilChanged } from 'rxjs';
import { Agreement } from 'src/app/domain/Agreement';
import { AppConfig } from 'src/app/domain/appconfig';
import { ConfigService } from 'src/app/services/app.config.service';
import { ClientService } from 'src/app/services/client.service';
import { StepperService } from 'src/app/pages/Shared/stepper/stepper.service';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductCatalogService } from 'src/app/services/product-catalog.service';
import { Colli } from 'src/app/domain/Colli';

@Component({
  templateUrl: './colli.component.html',
  selector: 'app-colli',
  styleUrls: ['./colli.component.scss'],
})
export class ColliComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() collies: Colli[] = new Array<Colli>();
  @Input() editColli?: any;
  @Input() removeBtns: boolean = false;
  @ViewChild('quantity') quantityField: any;
  @ViewChild('nextBtn') nextBtn: any;
  @ViewChild('weight') weightField: any;

  // config: AppConfig;
  subscription: Subscription;
  colli: any = {};
  agreements: Agreement[] = [];
  lastChosenType: any;
  colliCount = 0;
  products: any[] = [];
  loadMeterManuallyOverwritten = false;
  lastSuggestedLoadMeter: number | null = null;

  IsEuf = this.clientService.clientTenant == "Eurofins";

  ldmTypeValue: any;
  bookVolumeCalculation: string = 'book.volumecalculation';
  bookLdmCalculation: string = 'book.ldmcalculation';

  enableProductCatalog = this.authService.hasSetting('feat.itemcatalog');
  colliesFormArray = new FormArray([]);

  colliForm = new FormGroup({
    quantity: new FormControl(this.colli.quantity ?? 0, [Validators.min(1), Validators.required]),
    type: new FormControl(this.colli.type ?? "", Validators.required),
    description: new FormControl({ value: this.colli.description ?? "", disabled: true }, Validators.required),
    length: new FormControl({ value: this.colli.length ?? 0, disabled: true }),
    width: new FormControl({ value: this.colli.width ?? 0, disabled: true }),
    height: new FormControl({ value: this.colli.height ?? 0, disabled: true }),
    volume: new FormControl({ value: this.colli.volume ?? 0, disabled: true }),
    loadMeter: new FormControl({ value: this.colli.loadMeter ?? 0, disabled: true }),
    weight: new FormControl({ value: this.colli.weight ?? 0, disabled: true }),
    agreementId: new FormControl()

  });

  get CreateColliFormControll() {
    this.colliCount++;
    return new FormGroup({
      rowId: new FormControl(this.colliCount),
      quantity: new FormControl(0, Validators.required),
      type: new FormControl("", Validators.required),
      description: new FormControl("", Validators.required),
      length: new FormControl(),
      width: new FormControl(),
      height: new FormControl(),
      volume: new FormControl(),
      loadMeter: new FormControl(),
      weight: new FormControl(),
      AgreementId: new FormControl()
    })
  }

  get GetFormColliArray() {
    return this.colliesFormArray as FormArray;
  }

  // public configService: ConfigService,
  constructor(
    private messageService: MessageService,
    public stepperService: StepperService,
    private clientService: ClientService,
    public authService: AuthService,
    private translateService: TranslateService,
    private readonly productService: ProductCatalogService
  ) {
    this.agreements = this.clientService.clientAgreements;

    this.colliForm.valueChanges.subscribe((data) => {
      if (data.quantity != this.colli.quantity) {
        if (data.length && data.width) {
          if (!this.colliForm.get('length').hasError('max') && !this.colliForm.get('width').hasError('max') && !this.colliForm.get('height').hasError('max')) {
            if (this.authService.hasSetting(this.bookLdmCalculation)) {
              this.colli.loadMeter = (data.length * data.width) / 2.4;
              this.colli.loadMeter = (Math.round(this.colli.loadMeter?.toFixed(2) * 1e2) / 1e2) * data.quantity;
              this.colliForm.patchValue({ loadMeter: this.colli.loadMeter }, { emitEvent: false });
            }
          }
        }

        if (this.colli.loadMeter && this.colli.loadMeter > 0 && data.loadMeter == this.colli.loadMeter) {
          let basieLDM = this.colli.loadMeter / this.colli.quantity;
          data.loadMeter = basieLDM * data.quantity;
        }


      }
      this.colli.quantity = data.quantity;
      if (data.type) {
        this.colli.type = data.type.colliName;
      }
      this.colli.description = data.description;

      if (data.length <= 20 && !this.IsEuf) {
        this.colli.length = data.length;
      } else if (!this.IsEuf) {
        if (data.length) {
          this.colliForm.get('length').setErrors({ max: true }, { emitEvent: false });
        }
      }
      if (this.IsEuf) {
        this.colli.length = data.length;
      }

      if (data.width <= 4) {
        this.colli.width = data.width;
      } else {
        if (data.width) {
          this.colliForm.get('width').setErrors({ max: true }, { emitEvent: false });
        }
      }

      if (data.height <= 4) {
        this.colli.height = data.height;
      } else {
        if (data.height) {
          this.colliForm.get('height').setErrors({ max: true }, { emitEvent: false });
        }
      }

      this.colli.volume = data.volume;
      if (data.length && data.width && data.height) {
        if (!this.colliForm.get('length').hasError('max') && !this.colliForm.get('width').hasError('max') && !this.colliForm.get('height').hasError('max')) {
          if (this.authService.hasSetting(this.bookVolumeCalculation)) {
            this.colli.volume = data.length * data.width * data.height * data.quantity;
            this.colliForm.patchValue({ volume: this.colli.volume.toFixed(2) }, { emitEvent: false });
          }
        }
      }

      let currentLoadMeter = data.loadMeter;

      if (
        this.lastSuggestedLoadMeter !== null &&
        currentLoadMeter !== null &&
        currentLoadMeter !== undefined &&
        currentLoadMeter !== this.lastSuggestedLoadMeter
      ) {
        this.loadMeterManuallyOverwritten = true;
      }

      if (this.shouldSuggestLoadMeter(data)) {
        let suggestedLoadMeter = this.calculateSuggestedLoadMeter(data.length, data.width, data.quantity);
        this.lastSuggestedLoadMeter = suggestedLoadMeter;
        this.colli.loadMeter = suggestedLoadMeter;
        this.colliForm.patchValue({ loadMeter: suggestedLoadMeter }, { emitEvent: false });
      } else {
        this.colli.loadMeter = data.loadMeter;
      }

      // this.colli.loadMeter = data.loadMeter;
      // if (data.length && data.width) {
      //   if (!this.colliForm.get('length').hasError('max') && !this.colliForm.get('width').hasError('max') && !this.colliForm.get('height').hasError('max')) {
      //     if (this.authService.hasSetting(this.bookLdmCalculation)) {
      //       this.colli.loadMeter = (data.length * data.width) / 2.4;
      //       this.colli.loadMeter = (Math.round(this.colli.loadMeter?.toFixed(2) * 1e2) / 1e2) * data.quantity;
      //       this.colliForm.patchValue({ loadMeter: this.colli.loadMeter }, { emitEvent: false });
      //     }
      //   }
      // }
      this.colli.weight = data.weight;
      if (this.editColli) {
        this.editColli = this.colli;
      }
      this.colli.agreementId = data.agreementId;
    });

    this.collies = this.stepperService.newShipment.collis;

    productService.getAll().subscribe((res) => {
      this.products = res;
    });

    this.setFormByAgreement();
    this.GetFormColliArray.statusChanges.subscribe(x => {
      if (x == "VALID") {
        this.ColliChangeSendSignal();
      }
    })
  }

  ngOnInit(): void {
    if (this.editColli) {
      this.colli = this.editColli;
      this.colliForm.patchValue({
        quantity: this.colli.quantity != null ? this.colli.quantity : 1,
        type: this.colli.agreementId ? this.clientService.clientAgreements.find((type) => type.id == this.colli.agreementId) : this.clientService.clientAgreements.find((type) => type.colliName === this.colli.type),
        description: this.colli.description ?? "",
        length: this.colli.length != null ? Math.round(this.colli.length * 1e2) / 1e2 : 0,
        width: this.colli.width != null ? Math.round(this.colli.width?.toFixed(2) * 1e2) / 1e2 : 0,
        height: this.colli.height != null ? Math.round(this.colli.height?.toFixed(2) * 1e2) / 1e2 : 0,
        volume: this.colli.volume != null ? Math.round(this.colli.volume?.toFixed(2) * 1e2) / 1e2 : 0,
        loadMeter: this.colli.loadMeter != null ? Math.round(this.colli.loadMeter?.toFixed(2) * 1e2) / 1e2 : 0,
        weight: this.colli.weight != null ? Math.round(this.colli.weight * 1e2) / 1e2 : 0,
        agreementId: this.colli.agreementId ?? null
      });
    }
  }

  isRequiredField(field: string) {
    const form_field = this.colliForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return validator && validator.required;
  }

  ngAfterViewInit(): void {
    this.MapColliFormControlls();
    setTimeout(() => {
      // Hack to get it focused without errors
      this.focusQuantityField();
    }, 0);
  }

  formattedColliName(item: Agreement) {
    if (item) {
      return `${item.colliName} (${item.name})`;
    }
    return '';
  }

  setFormByAgreement() {
    this.colliForm.get('type').valueChanges.pipe(distinctUntilChanged()).subscribe((type) => {
      if (type) {
        this.loadMeterManuallyOverwritten = false;
        this.lastSuggestedLoadMeter = null;

        this.colliForm.controls.description.patchValue(null);

        this.colliForm.controls.length.clearValidators();
        this.colliForm.controls.length.patchValue(null);

        this.colliForm.controls.width.clearValidators();
        this.colliForm.controls.width.patchValue(null);

        this.colliForm.controls.height.clearValidators();
        this.colliForm.controls.height.patchValue(null);

        this.colliForm.controls.volume.clearValidators();
        this.colliForm.controls.volume.patchValue(null);

        this.colliForm.controls.loadMeter.clearValidators();
        this.colliForm.controls.loadMeter.patchValue(null);

        this.colliForm.controls.weight.clearValidators();
        this.colliForm.controls.weight.patchValue(null);        

        this.colliForm.enable({ emitEvent: false });

        if (type.name) {
          if (this.checkSpecificClientHackMethodPleaseRemoveASAP()) {
            this.colli.description = type.name;
            this.colliForm.patchValue({ description: this.colli.description });
          }
        }

        if (type.text)
          this.setFormFieldToRequired('description');
        if (type.length)
          this.setFormFieldToRequired('length');
        if (type.width)
          this.setFormFieldToRequired('width');
        if (type.height)
          this.setFormFieldToRequired('height');
        if (type.volume)
          this.setFormFieldToRequired('volume');
        if (type.ldm)
          this.setFormFieldToRequired('loadMeter');
        if (type.weight)
          this.setFormFieldToRequired('weight');


        if (type.ldmValue) {
          this.ldmTypeValue = type.ldmValue * this.colli.quantity;
          this.colli.loadMeter = type.ldmValue * this.colli.quantity;
          this.colliForm.patchValue({ loadMeter: this.colli.loadMeter }, { emitEvent: false });
        }
        this.colliForm.controls.agreementId.reset();

        this.colli.typeCode = type.code;
      }
    });
  }

  // TODO : ↓ Remove this  when implemented correctly ↓
  checkSpecificClientHackMethodPleaseRemoveASAP() {
    if (this.clientService.clientTenantName == 'tjw' && this.clientService.defaultClientNumber == '43964246') {
      return true;
    }
    return false;
  }

  setFormFieldToRequired(field: string) {
    this.colliForm.get(field).setValidators(Validators.required);
    this.colliForm.get(field).updateValueAndValidity({ emitEvent: false });
  }

  focusHeightLost() {
    if (this.colli.length && this.colli.width && this.colli.height && this.colli.volume && this.colli.loadMeter && !this.colli.weight) {
      this.weightField.input.nativeElement.focus();
    }
  }

  checkNextBtn() {
    if (this.collies.length > 0) {
      return false;
    } else if (this.colliForm.valid) {
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onEnter() {
    if (this.colliForm.valid) {
      this.saveColli();
    } else {
      this.messageService.add({
        severity: 'info',
        summary: this.translateService.instant('MESSAGES.FILLMISSINGFIELDS'),
        detail: this.translateService.instant('MESSAGES.FILLMISSINGIFIELDSANDTRYAGAIN'),
      });
    }
  }

  addColli() {
    if (this.colliForm.valid) {
      this.saveColli();
    }
  }

  saveColli() {
    this.messageService.add({
      severity: 'success',
      summary: this.translateService.instant('MESSAGES.COLLIADDEDTOBOOKING'),
      detail: this.translateService.instant('ADDED') + this.colli.quantity + ' ' + this.colli.type,
    });
    if (!this.collies)
      this.collies = new Array<Colli>();
    if (this.colli.quantity < 1)
      this.colli.quantity = 1;

    this.collies.push(this.colli);
    this.colli = {};
    this.colliForm.reset();
    this.colliForm.disable();
    this.colliForm.controls.quantity.enable();
    this.colliForm.controls.type.enable();
    this.colliForm.controls.length.clearValidators();
    this.colliForm.controls.width.clearValidators();
    this.colliForm.controls.height.clearValidators();
    this.colliForm.controls.volume.clearValidators();
    this.colliForm.controls.loadMeter.clearValidators();
    this.colliForm.controls.weight.clearValidators();
    this.colliForm.controls.agreementId.reset();
    this.ldmTypeValue = null;

    this.MapColliFormControlls();
    window.dispatchEvent(new CustomEvent("CheckPriceEvent", {}));
    this.focusQuantityField();
  }

  focusQuantityField() {
    this.quantityField.input.nativeElement.focus();
  }

  applyProduct(product: any) {
    let quantity = this.colli.quantity;

    if (!quantity) {
      quantity = 1;
    }
    product.collis.forEach((colli) => {
      this.colli = {
        quantity: quantity,
        type: colli.type,
        description: colli.description,
        weight: (colli.weight ?? 0) * quantity,
        length: colli.length,
        width: colli.width,
        height: colli.height,
        volume: (colli.volume ?? 0) * quantity,
        loadMeter: (colli.loadMeter ?? 0) * quantity,
        typeCode: this.agreements.find(x => x.id == colli.agreementId)?.code ?? ""

      };
      this.saveColli();
    });
  }

  showError(field: string): boolean {
    const validateField = this.colliForm.get(field);
    if (validateField == null)
      return true;
    return !validateField.valid && validateField.touched;
  }
  /**
   * this maps this.collis to a formarray for the tablen shownd in view.
   */
  MapColliFormControlls() {
    this.GetFormColliArray.clear();

    if (this.collies != null && this.collies.length > 0)
      this.collies.forEach(colli => {
        let temp = this.CreateColliFormControll;
        temp.controls.description.setValue(colli.description);
        temp.controls.height.setValue(colli.height ?? 0);
        temp.controls.length.setValue(colli.length ?? 0);
        temp.controls.loadMeter.setValue(colli.loadMeter ?? 0);
        temp.controls.quantity.setValue(colli.quantity ?? 0);
        temp.controls.type.setValue(colli.type ?? 0);
        temp.controls.volume.setValue(colli.volume ?? 0);
        temp.controls.weight.setValue(colli.weight ?? 0);
        temp.controls.width.setValue(colli.width ?? 0);
        temp.controls.AgreementId.setValue(colli.agreementId ?? null);
        this.GetFormColliArray.push(temp)
      })
  }

  //#region "ColliEdit" 
  // this section is to be used when a editable table is implemented (the code is in the html but uncommented)

  /**
   * this event is used for decting when a user deletes a colli from bookingOverView,
   * then this clears the formarray and builds its agine.
   * @param event a list of collis
   */
  @HostListener("window:ColliDeleteEvent", ["$event"])
  ColliDeleteEvent(event: any) {
    if (event.detail != null) {
      if (event.detail.length > 0)
        this.collies = event.detail;
      else
        this.collies = new Array<Colli>();
      this.MapColliFormControlls();
    }
  }


  ColliChangeSendSignal() {
    let tempColliArry = new Array<Colli>();
    this.GetFormColliArray.controls.forEach((x: FormGroup<{ quantity: FormControl, type: FormControl, description: FormControl, length: FormControl, width: FormControl, height: FormControl, volume: FormControl, loadMeter: FormControl, weight: FormControl, agreementId: FormControl }>) => {
      tempColliArry.push({
        quantity: x.controls.quantity.value ?? 1,
        description: x.controls.description.value ?? "",
        height: x.controls.height.value ?? 0,
        length: x.controls.length.value ?? 0,
        loadMeter: x.controls.loadMeter.value ?? 0,
        width: x.controls.width.value ?? 0,
        type: x.controls.type.value ?? "",
        weight: x.controls.weight.value ?? 0,
        volume: x.controls.volume.value ?? 0,
        agreementId: x.controls.agreementId?.value ?? null
      } as Colli)
    })
    // window.dispatchEvent(new CustomEvent("ColliEdited", { detail: tempColliArry }));
  }

  onDeleteRow(rowid: number) {
    let indexToRemove = this.GetFormColliArray.controls.findIndex(x => x.get('rowId').value == rowid);
    this.GetFormColliArray.removeAt(indexToRemove);
  }

  GetTotalWeight() {
    let sum = 0;
    this.colliesFormArray.controls.forEach(x => {
      sum += x.get("weight").value;
    })
    return sum;
  }

  GetQuantitySum() {
    let sum = 0;
    this.colliesFormArray.controls.forEach(x => {
      sum += x.get("quantity").value;
    })
    return sum;
  }

  GetLoadMeterSum() {
    let sum = 0;
    this.colliesFormArray.controls.forEach((x: FormGroup) => {
      sum += x.get("loadMeter").value;
    })
    return sum;
  }

  GetTotalVolume() {
    let sum = 0;
    this.colliesFormArray.controls.forEach((x: FormGroup) => {
      sum += x.get("volume").value;
    })
    return sum;
  }
  calculateSuggestedLoadMeter(length: number, width: number, quantity: number): number {
    if (length == undefined || width == undefined)
      return 0.0;
    const safeQuantity = quantity && quantity > 0 ? quantity : 1;

    const singleLdm = (length * width) / 2.4;
    const totalLdm = singleLdm * safeQuantity;

    return Math.round(totalLdm * 100) / 100;
  }

  shouldSuggestLoadMeter(data: any): boolean {
    if (data != undefined && data.type != undefined)
      return !!data.type.length
        && !!data.type.width
        && !!data.type.ldm
        && !this.colliForm.get('length')?.hasError('max')
        && !this.colliForm.get('width')?.hasError('max')
        && !this.colliForm.get('height')?.hasError('max')
        && !this.loadMeterManuallyOverwritten;
    else
      return false
  }
  FindAgrementId(event: any) {
    this.colliForm.controls.agreementId.setValue(event.value.id);
  }
  //#endregion "ColliEdit"
}
